// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"181":"030b5881","251":"a63c76d1","254":"6df01b9a","536":"f7aacd57"}[chunkId] + ".css";
};